import * as types from './ticketTypes';

// Initial state for tickets
const initialState = {
  // Admin inbox state
  adminInbox: {
    tickets: [],
    totalTickets: 0,
    loading: false,
    error: null,
    page: 1,
    limit: 20,
    pages: 1,
    filters: {
      category: '',
      status: '',
      search: ''
    },
    selectedTicket: null,
    ticketLoading: false,
    ticketError: null,
    replyLoading: false,
    replyError: null
  },
  
  // User tickets state
  user: {
    tickets: [],
    totalTickets: 0,
    loading: false,
    error: null,
    page: 1,
    limit: 10,
    pages: 1,
    selectedTicket: null,
    ticketLoading: false,
    replyLoading: false
  },
  
  // Ticket submission state
  submission: {
    loading: false,
    success: false,
    error: null,
    fieldErrors: {}
  }
};

// Ticket reducer
const ticketReducer = (state = initialState, action) => {
  switch (action.type) {
    // Admin inbox cases
    case types.ADMIN_INBOX_FETCH_REQUEST:
      return {
        ...state,
        adminInbox: {
          ...state.adminInbox,
          loading: true,
          error: null
        }
      };
    case types.ADMIN_INBOX_FETCH_SUCCESS:
      return {
        ...state,
        adminInbox: {
          ...state.adminInbox,
          loading: false,
          tickets: action.payload.tickets,
          totalTickets: action.payload.totalTickets,
          page: action.payload.page,
          limit: action.payload.limit,
          pages: action.payload.pages
        }
      };
    case types.ADMIN_INBOX_FETCH_FAILURE:
      return {
        ...state,
        adminInbox: {
          ...state.adminInbox,
          loading: false,
          error: action.payload.error
        }
      };
    
    // Admin inbox filters update
    case types.ADMIN_INBOX_UPDATE_FILTERS:
      return {
        ...state,
        adminInbox: {
          ...state.adminInbox,
          filters: {
            ...state.adminInbox.filters,
            ...action.payload
          },
          ...(action.payload.page !== undefined ? { page: action.payload.page } : {})
        }
      };
    
    // Admin inbox ticket detail cases
    case types.ADMIN_INBOX_TICKET_DETAIL_REQUEST:
      return {
        ...state,
        adminInbox: {
          ...state.adminInbox,
          ticketLoading: true,
          ticketError: null
        }
      };
    case types.ADMIN_INBOX_TICKET_DETAIL_SUCCESS:
      return {
        ...state,
        adminInbox: {
          ...state.adminInbox,
          selectedTicket: action.payload.ticket,
          ticketLoading: false
        }
      };
    case types.ADMIN_INBOX_TICKET_DETAIL_FAILURE:
      return {
        ...state,
        adminInbox: {
          ...state.adminInbox,
          ticketLoading: false,
          ticketError: action.payload.error
        }
      };
    
    // Admin inbox reply cases
    case types.ADMIN_INBOX_REPLY_REQUEST:
      return {
        ...state,
        adminInbox: {
          ...state.adminInbox,
          replyLoading: true,
          replyError: null
        }
      };
    case types.ADMIN_INBOX_REPLY_SUCCESS:
      return {
        ...state,
        adminInbox: {
          ...state.adminInbox,
          replyLoading: false,
          selectedTicket: action.payload.ticket,
          // Update the ticket in the list as well
          tickets: state.adminInbox.tickets.map(ticket => 
            ticket.ticketId === action.payload.ticket.ticketId ? action.payload.ticket : ticket
          )
        }
      };
    case types.ADMIN_INBOX_REPLY_FAILURE:
      return {
        ...state,
        adminInbox: {
          ...state.adminInbox,
          replyLoading: false,
          replyError: action.payload.error
        }
      };
    
    // Admin inbox status update cases
    case types.ADMIN_INBOX_UPDATE_STATUS_REQUEST:
      return {
        ...state,
        adminInbox: {
          ...state.adminInbox,
          ticketLoading: true,
          ticketError: null
        }
      };
    case types.ADMIN_INBOX_UPDATE_STATUS_SUCCESS:
      return {
        ...state,
        adminInbox: {
          ...state.adminInbox,
          ticketLoading: false,
          selectedTicket: action.payload.ticket,
          tickets: state.adminInbox.tickets.map(ticket => 
            ticket.ticketId === action.payload.ticket.ticketId ? action.payload.ticket : ticket
          )
        }
      };
    case types.ADMIN_INBOX_UPDATE_STATUS_FAILURE:
      return {
        ...state,
        adminInbox: {
          ...state.adminInbox,
          ticketLoading: false,
          ticketError: action.payload.error
        }
      };
    
    // Admin inbox category update cases
    case types.ADMIN_INBOX_UPDATE_CATEGORY_REQUEST:
      return {
        ...state,
        adminInbox: {
          ...state.adminInbox,
          ticketLoading: true,
          ticketError: null
        }
      };
    case types.ADMIN_INBOX_UPDATE_CATEGORY_SUCCESS:
      return {
        ...state,
        adminInbox: {
          ...state.adminInbox,
          ticketLoading: false,
          selectedTicket: action.payload.ticket,
          // Update the ticket in the list as well
          tickets: state.adminInbox.tickets.map(ticket => 
            ticket.ticketId === action.payload.ticket.ticketId ? action.payload.ticket : ticket
          )
        }
      };
    case types.ADMIN_INBOX_UPDATE_CATEGORY_FAILURE:
      return {
        ...state,
        adminInbox: {
          ...state.adminInbox,
          ticketLoading: false,
          ticketError: action.payload.error
        }
      };
    
    // Admin inbox notes update cases
    case types.ADMIN_INBOX_UPDATE_NOTES_REQUEST:
      return {
        ...state,
        adminInbox: {
          ...state.adminInbox,
          ticketLoading: true,
          ticketError: null
        }
      };
    case types.ADMIN_INBOX_UPDATE_NOTES_SUCCESS:
      return {
        ...state,
        adminInbox: {
          ...state.adminInbox,
          ticketLoading: false,
          selectedTicket: action.payload.ticket,
          // Update the ticket in the list as well
          tickets: state.adminInbox.tickets.map(ticket => 
            ticket.ticketId === action.payload.ticket.ticketId ? action.payload.ticket : ticket
          )
        }
      };
    case types.ADMIN_INBOX_UPDATE_NOTES_FAILURE:
      return {
        ...state,
        adminInbox: {
          ...state.adminInbox,
          ticketLoading: false,
          ticketError: action.payload.error
        }
      };
    
    // Admin inbox ticket deletion cases
    case types.ADMIN_INBOX_DELETE_TICKET_REQUEST:
      return {
        ...state,
        adminInbox: {
          ...state.adminInbox,
          ticketLoading: true,
          ticketError: null
        }
      };
    case types.ADMIN_INBOX_DELETE_TICKET_SUCCESS:
      return {
        ...state,
        adminInbox: {
          ...state.adminInbox,
          ticketLoading: false,
          selectedTicket: null,
          // Remove the deleted ticket from the list
          tickets: state.adminInbox.tickets.filter(ticket => 
            ticket.ticketId !== action.payload.ticketId
          ),
          totalTickets: state.adminInbox.totalTickets - 1
        }
      };
    case types.ADMIN_INBOX_DELETE_TICKET_FAILURE:
      return {
        ...state,
        adminInbox: {
          ...state.adminInbox,
          ticketLoading: false,
          ticketError: action.payload.error
        }
      };
    
    // Clear selected ticket
    case types.ADMIN_INBOX_CLEAR_SELECTED_TICKET:
      return {
        ...state,
        adminInbox: {
          ...state.adminInbox,
          selectedTicket: null,
          ticketError: null
        }
      };
      
    // User ticket fetch cases
    case types.USER_TICKET_FETCH_REQUEST:
      return {
        ...state,
        user: {
          ...state.user,
          loading: true,
          error: null
        }
      };
    case types.USER_TICKET_FETCH_SUCCESS:
      return {
        ...state,
        user: {
          ...state.user,
          loading: false,
          tickets: action.payload.tickets,
          totalTickets: action.payload.totalTickets,
          page: action.payload.page,
          limit: action.payload.limit,
          pages: action.payload.pages
        }
      };
    case types.USER_TICKET_FETCH_FAILURE:
      return {
        ...state,
        user: {
          ...state.user,
          loading: false,
          error: action.payload.error
        }
      };
    
    // User ticket detail cases
    case types.USER_TICKET_DETAIL_REQUEST:
      return {
        ...state,
        user: {
          ...state.user,
          ticketLoading: true
        }
      };
    case types.USER_TICKET_DETAIL_SUCCESS:
      return {
        ...state,
        user: {
          ...state.user,
          ticketLoading: false,
          selectedTicket: action.payload.ticket
        }
      };
    case types.USER_TICKET_DETAIL_FAILURE:
      return {
        ...state,
        user: {
          ...state.user,
          ticketLoading: false,
          error: action.payload.error
        }
      };
    
    // User ticket reply cases
    case types.USER_TICKET_REPLY_REQUEST:
      return {
        ...state,
        user: {
          ...state.user,
          replyLoading: true
        }
      };
    case types.USER_TICKET_REPLY_SUCCESS:
      return {
        ...state,
        user: {
          ...state.user,
          replyLoading: false,
          selectedTicket: action.payload.ticket,
          // Update the ticket in the list as well
          tickets: state.user.tickets.map(ticket => 
            ticket.ticketId === action.payload.ticket.ticketId ? action.payload.ticket : ticket
          )
        }
      };
    case types.USER_TICKET_REPLY_FAILURE:
      return {
        ...state,
        user: {
          ...state.user,
          replyLoading: false,
          error: action.payload.error
        }
      };
    
    // User ticket submission cases
    case types.USER_TICKET_SUBMIT_REQUEST:
      return {
        ...state,
        submission: {
          loading: true,
          success: false,
          error: null,
          fieldErrors: {}
        }
      };
    case types.USER_TICKET_SUBMIT_SUCCESS:
      return {
        ...state,
        submission: {
          loading: false,
          success: true,
          error: null,
          fieldErrors: {}
        }
      };
    case types.USER_TICKET_SUBMIT_FAILURE:
      return {
        ...state,
        submission: {
          loading: false,
          success: false,
          error: action.payload.error,
          fieldErrors: action.payload.fieldErrors || {}
        }
      };
      
    // User feedback submission cases
    case types.USER_FEEDBACK_SUBMIT_REQUEST:
      return {
        ...state,
        submission: {
          loading: true,
          success: false,
          error: null,
          fieldErrors: {}
        }
      };
    case types.USER_FEEDBACK_SUBMIT_SUCCESS:
      return {
        ...state,
        submission: {
          loading: false,
          success: true,
          error: null,
          fieldErrors: {}
        }
      };
    case types.USER_FEEDBACK_SUBMIT_FAILURE:
      return {
        ...state,
        submission: {
          loading: false,
          success: false,
          error: action.payload.error,
          fieldErrors: action.payload.fieldErrors || {}
        }
      };
    
    // Clear selected user ticket
    case 'USER_TICKET_CLEAR_SELECTED':
      return {
        ...state,
        user: {
          ...state.user,
          selectedTicket: null
        }
      };
      
    default:
      return state;
  }
};

export default ticketReducer;
